import axios from 'axios';
import { useUserStore } from '@/store/user';

const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;
// const emailcontent  = "<script>alert('Email XSS')</script>";
// const entityAddress = "<div onclick='alert(\"XSS\")'>Click me</div>";
// const customcontent = "<span style='color:red'>This is red</span>";

export const RescheduleEntireBooking = (booking_id) => {
    const token = localStorage.getItem('authToken');
    //const userStore = useUserStore();
    //const token = userStore.authToken;
    return axios.post(apiUrl+"response/booking/reschedule", { booking_id: booking_id },
        { headers: { Authorization: `Bearer ${token}` }}
    );
};

export const CancelEntireBooking = (booking_id) => {
    const token = localStorage.getItem('authToken');
    //const userStore = useUserStore();
    //const token = userStore.authToken;
    return axios.post(apiUrl+"response/booking/cancel", { booking_id: booking_id },
        { headers: { Authorization: `Bearer ${token}` }}
    );
};

export const LogoutPage = () => {
    const userStore = useUserStore();
    const token = userStore.authToken || localStorage.getItem('authToken');
    ///console.log('token logout api :', token);
    return axios.post(apiUrl + "logout", {}, { headers: { Authorization: `Bearer ${token}` } });
};